import React from 'react';
import { I18nextProvider } from 'react-i18next';

import { TpaSettingsProvider } from '@wix/tpa-settings/dist/src/contexts';
import loadable from '@loadable/component';
import { Provider } from 'react-redux';

const Settings = loadable(() => import('./settings.js'), {
  ssr: false,
  fallback: <div />,
});
const SettingsMobile = loadable(
  () => import('./settingsMobile/settingsMobile'),
  {
    ssr: false,
    fallback: <div />,
  },
);
import i18n from '../../i18n';

import './style/Settings.global.scss';

const SettingsRoot = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return <div />;
  }
  const locale = (window && window.Wix.Utils.getLocale()) || 'en';
  const isMobile = window.Wix.Utils.getDeviceType() === 'mobile' || false;
  return (
    <TpaSettingsProvider Wix={window.Wix}>
      <I18nextProvider i18n={i18n(locale)}>
        {isMobile ? <SettingsMobile /> : <Settings />}
      </I18nextProvider>
    </TpaSettingsProvider>
  );
};

export default SettingsRoot;
